import { object, string } from 'yup'

export type Customer = {
    id: string
    firstName: string | null
    lastName: string | null
    email: string | null
    phone: string | null
    image: {
        id: string | null
        path: string | null
    }
    description: string | null
    externalId: string | null
    externalSource: string | null
}

export type BookingSlotCustomer = Pick<Customer, 'firstName' | 'lastName' | 'email'>

export const CustomerFormSchema = () => object({
    firstName:    string().nullable(),
    lastName:     string().nullable(),
    email:        string().nullable(),
    phone:        string().nullable(),
    billingPhone: string().nullable(),
    description:  string().nullable()
})
